/** author：胡枭 */
<template>
  <div class="side-bar">
    <el-scrollbar>
      <el-menu
        menu-trigger="click"
        :collapse="isCollapse"
        :collapse-transition="false"
        :default-openeds="openIds"
      >
        <sub-menu
          v-for="route in routeShowList"
          :key="route.id"
          :expand-menu="route"
          :time="1"
        />
      </el-menu>
    </el-scrollbar>
    <div v-if="!isIE" class="collapse-button" @click="collapse">
      <a-icon v-if="isCollapse" type="menu-unfold" />
      <a-icon v-else type="menu-fold" />
    </div>
  </div>
</template>

<script>
import SubMenu from '@/layout/components/SideBar/SubMenu'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Sidebar',

  components: {
    SubMenu
  },

  data() {
    return {
      isCollapse: sessionStorage.getItem('sidebarStatus')
        ? !!+sessionStorage.getItem('sidebarStatus')
        : false
    }
  },

  computed: {
    ...mapState('system', ['isIE']),
    ...mapGetters('router', ['expandMenuList']),

    // 需要展示的路由
    routeShowList() {
      return this.expandMenuList.filter(route => {
        return !route?.meta?.hidden
      })
    },

    openIds() {
      return [String((this.$route?.meta?.breadcrumb || [])[1]?.id || '')]
    }
  },

  mounted() {
    const sideWidth = this.isCollapse ? '60px' : '230px'
    this.setSideCollapse(this.isCollapse)
    document
      .getElementsByTagName('body')[0]
      .style.setProperty('--sideWidth', sideWidth)
  },

  methods: {
    ...mapActions('system', ['setSideCollapse']),
    collapse() {
      this.isCollapse = !this.isCollapse
      const sidebarStatus = this.isCollapse ? '1' : '0'
      sessionStorage.setItem('sidebarStatus', sidebarStatus)
      const sideWidth = this.isCollapse ? '60px' : '230px'
      this.setSideCollapse(this.isCollapse)
      document
        .getElementsByTagName('body')[0]
        .style.setProperty('--sideWidth', sideWidth)
    }
  }
}
</script>

<style lang="scss" scoped>
$collapse-height: 56px;

.side-bar {
  position: relative;

  ::v-deep .el-scrollbar {
    height: 100%;
    padding-bottom: calc(#{$collapse-height} + 16px);

    .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }

    .el-menu {
      border: none;
    }
  }

  .collapse-button {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 90;
    background-color: $white-color;
    width: $side-width;
    transition: width 0.28s;
    height: $collapse-height;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 18px;
    text-align: left;
    padding: 0 20px;
    border-top: 1px solid $info-fourth-color;
    &:hover {
      color: $primary-color;
    }
  }
}

::v-deep .el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none !important;
}

::v-deep .el-menu--collapse > div > .el-submenu > .el-submenu__title span {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}
</style>
